import { Injectable } from '@angular/core';
import { SubmitCompanyHouseModel } from '@app/core/Models/report/submitCompanyHouse/submit';
import { SubmitService } from '@app/core/Services/report/submit.service';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { CheckPrevalidationErrors, DeleteSubmittedFile, GetGatewayDetails, GetSubmitAccountDetails, GetSubmitMainGridDetails, PreviewHtmlReportFile, ShowStatusMessage, SubmitReport, SubmitReportDownloadHTML, SubmitReportDownloadPDF } from './submit.action';

export class SubmitStateInfo {
  submitAccountDetails?: SubmitCompanyHouseModel 
  isSuccess?: any;
  reportDetails?: any;
  gatewayDetails?: any;
  fileDetails?: any;
  message?: string;
  reports?: any[];
  submissionDetails?: any[];
  submitStatusDetails?:any;
}

@State<SubmitStateInfo>({
  name: 'SubmitCompanyHouse',
  defaults: {
    isSuccess: true
  },
})

@Injectable()
export class SubmitState {
  constructor(private submitService: SubmitService) {}

  @Action(CheckPrevalidationErrors)
  checkPrevalidationErrors(
    { patchState }: StateContext<SubmitStateInfo>,
    action: CheckPrevalidationErrors
  ) {
    return this.submitService.checkPrevalidationErrors(action.id, action.periodId)
      .pipe(
        tap((res) => {
          patchState({
            reports: res,
          });
        })
      );
  }

  @Action(PreviewHtmlReportFile)
  PreviewHtmlReportFile(
    { patchState }: StateContext<SubmitStateInfo>,
    action: PreviewHtmlReportFile
  ) {
    return this.submitService.previewHtmlReportFile(action.id, action.periodId)
      .pipe(
        tap((res) => {
          patchState({
            fileDetails: res,
          });
        })
      );
  }

  @Action(SubmitReport)
  submitReport(
    { patchState }: StateContext<SubmitStateInfo>,
    action: SubmitReport
  ) {
    return this.submitService.submitReport(action.reportDetails)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res.status,
            message: res.message
          });
        })
      );
  }

  @Action(GetGatewayDetails)
  GetGatewayDetails(
    { patchState }: StateContext<SubmitStateInfo>,
    action: GetGatewayDetails
  ) {
    return this.submitService.getGatewayDetails(action.id)
      .pipe(
        tap((res) => {
          patchState({
            gatewayDetails: res,
          });
        })
      );
  }

  @Action(GetSubmitAccountDetails)
  GetSubmitAccountDetails(
    { patchState }: StateContext<SubmitStateInfo>,
    action: GetSubmitAccountDetails
  ) {
    return this.submitService.getSubmitAccountDetails(action.id)
      .pipe(
        tap((res) => {
          patchState({
            submitAccountDetails: res,
          });
        })
      );
  }

  @Action(GetSubmitMainGridDetails)
  GetSubmitMainGridDetails(
    { patchState }: StateContext<SubmitStateInfo>,
    action: GetSubmitMainGridDetails
  ) {
    return this.submitService.getSubmitMainGridDetails(action.periodId)
      .pipe(
        tap((res) => {
          patchState({
            submissionDetails: res,
          });
        })
      );
  }

  @Action(SubmitReportDownloadHTML)
  SubmitReportDownloadHTML(
    { patchState }: StateContext<SubmitStateInfo>,
    action: SubmitReportDownloadHTML
  ) {
    return this.submitService.submitReportDownloadHTML(action.id, action.periodId)
      .pipe(
        tap((res) => {
          patchState({
            fileDetails: res,
          });
        })
      );
  }

  @Action(SubmitReportDownloadPDF)
  SubmitReportDownloadPDF(
    { patchState }: StateContext<SubmitStateInfo>,
    action: SubmitReportDownloadPDF
  ) {
    return this.submitService.submitReportDownloadPDF(action.submitId, action.periodId)
      .pipe(
        tap((res) => {
          patchState({
            fileDetails: res,
          });
        })
      );
  }
  
  @Action(DeleteSubmittedFile)
  deleteSubmittedFile(
    { patchState }: StateContext<SubmitStateInfo>,
    action: DeleteSubmittedFile
  ) {
    return this.submitService.deleteSubmittedFile(action?.submitId)
      .pipe(
        tap((res) => {
          patchState({
            isSuccess: res,
          });
        })
      );
  }

  @Action(ShowStatusMessage)
  GetStatusMessage(
    { patchState }: StateContext<SubmitStateInfo>,
    action: ShowStatusMessage
  ) {
    return this.submitService.getMessageDetail(action.id)
      .pipe(
        tap((res) => {
          patchState({
            submitStatusDetails: res,
          });
        })
      );
  }
}
